import { RolesTypes } from './actionTypes';

export const getRoles = (data: any) => ({
  type: RolesTypes.GET_ROLES,
  payload: data,
});

export const getRolesSuccess = (roles: any) => ({
  type: RolesTypes.GET_ROLES_SUCCESS,
  payload: roles,
});

export const getRolesFail = (error: any) => ({
  type: RolesTypes.GET_ROLES_FAIL,
  payload: error,
});

export const getRolesDetail = (roleId: number) => ({
  type: RolesTypes.GET_ROLES_DETAIL,
  roleId,
});

export const getRolesDetailSuccess = (roles: any) => ({
  type: RolesTypes.GET_ROLES_DETAIL_SUCCESS,
  payload: roles,
});

export const getRolesDetailFail = (error: any) => ({
  type: RolesTypes.GET_ROLES_DETAIL_FAIL,
  payload: error,
});

export const addRoles = (rolesAdd: any) => {
  return {
    type: RolesTypes.ADD_ROLES,
    payload: { rolesAdd },
  };
};

export const addRolesSuccess = (rolesAdd: any) => {
  return {
    type: RolesTypes.ADD_ROLES_SUCCESS,
    payload: rolesAdd,
  };
};

export const addRolesFail = (error: any) => {
  return {
    type: RolesTypes.ADD_ROLES_FAIL,
    payload: error,
  };
};

export const deleteRoles = (id: any) => {
  return {
    type: RolesTypes.DELETE_ROLES,
    payload: { id },
  };
};

export const deleteRolesSuccess = (payload: any) => {
  return {
    type: RolesTypes.DELETE_ROLES_SUCCESS,
    payload,
  };
};

export const deleteRolesFail = (error: any) => {
  return {
    type: RolesTypes.DELETE_ROLES_FAIL,
    payload: error,
  };
};

export const updateRoles = (role: any) => {
  return {
    type: RolesTypes.UPDATE_ROLES,
    payload: { role },
  };
};

export const updateRolPermisiosn = (rol: any) => {
  return {
    type: RolesTypes.UPDATE_ROL_PERMISSIONS,
    payload: rol,
  };
};

export const updateRolesSuccess = (role: any) => {
  return {
    type: RolesTypes.UPDATE_ROLES_SUCCESS,
    payload: role,
  };
};

export const updateRolesFail = (error: any) => {
  return {
    type: RolesTypes.UPDATE_ROLES_FAIL,
    payload: error,
  };
};
